<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/cessation/plan/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>

			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setAddEnable()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<!-- 自定义某个字段 -->

			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/production/cessation/plan/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<!-- <div class="dialog-scroller"> -->
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('tingchanjihuamingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('tingchanleixing')" required>
						<yi_dictionary_select :type="'SHUTDOWN_TYPE'" :ids.sync="yt.editObj.shutdownType">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='2'" :label="$t('anzhouzhiding')" required>
						<yi_dictionary_select :type="'SPECIFY_BY_WEEK'" :ids.sync="yt.editObj.weekly">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='1'" :label="$t('tingchankaishishijian')" required>
						<yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime"
							:time.sync="yt.editObj.specifyStartTime">
						</yi_time_input>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='1'" :label="$t('tingchanjieshushijian')" required>
						<yi_time_input format="yyyy-MM-dd HH:mm:ss" @change="changeClick" type="datetime"
							:time.sync="yt.editObj.specifyEndTime">
						</yi_time_input>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='2'" :label="$t('anzhoutingchankaishishijian')"
						required>

						<el-time-picker v-model="yt.editObj.weekStartTime" value-format="HH:mm:ss">
						</el-time-picker>

					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='2'" :label="$t('anzhoutingchanjieshushijian')"
						required>
						<el-time-picker v-model="yt.editObj.weekEndTime" value-format="HH:mm:ss">
						</el-time-picker>

					</el-form-item>
					<el-form-item :label="$t('miaoshu')">
						<el-input v-model="yt.editObj.remark"></el-input>
					</el-form-item>

				</el-form>
				<!-- </div> -->
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/production/cessation/plan/create',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('tingchanjihuamingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('tingchanleixing')" required>
						<yi_dictionary_select :type="'SHUTDOWN_TYPE'" :ids.sync="yt.editObj.shutdownType">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='2'" :label="$t('anzhouzhiding')" required>
						<yi_dictionary_select :type="'SPECIFY_BY_WEEK'" :ids.sync="yt.editObj.weekly">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='1'" :label="$t('tingchankaishishijian')" required>
						<yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime"
							:time.sync="yt.editObj.specifyStartTime">
						</yi_time_input>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='1'" :label="$t('tingchanjieshushijian')" required>
						<yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime"
							:time.sync="yt.editObj.specifyEndTime">
						</yi_time_input>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='2'" :label="$t('anzhoutingchankaishishijian')"
						required>
						<el-time-picker v-model="yt.editObj.weekStartTime" value-format="HH:mm:ss">
						</el-time-picker>
					</el-form-item>
					<el-form-item v-show="yt.editObj.shutdownType=='2'" :label="$t('anzhoutingchanjieshushijian')"
						required>
						<el-time-picker v-model="yt.editObj.weekEndTime" value-format="HH:mm:ss">
						</el-time-picker>
					</el-form-item>
					<el-form-item :label="$t('miaoshu')">
						<el-input v-model="yt.editObj.remark"></el-input>
					</el-form-item>

				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/production/cessation/plan/update',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>



		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_scheduling_calendar_plan_stop_production_list',
		data() {
			return {
				shifts: [],
				columns: [{
					label: 'tingchanjihuamingcheng',
					prop: 'name',
				}, {
					label: 'tingchanleixing',
					prop: 'shutdownType',
					type: 'dictionary',
					key: 'SHUTDOWN_TYPE',

				}, {
					label: 'anzhouzhiding',
					prop: 'weekly',
					type: 'dictionary',
					key: 'SPECIFY_BY_WEEK',
				}, {
					label: 'tingchankaishishijian',
					prop: 'specifyStartTime',
					type: 'time',
					format: 'YYYY-MM-DD HH:mm:ss'
				}, {
					label: 'tingchanjieshushijian',
					prop: 'specifyEndTime',
					type: 'time',
					format: 'YYYY-MM-DD HH:mm:ss'
				}, {
					label: 'anzhoutingchankaishishijian',
					prop: 'weekStartTime',
				}, {
					label: 'anzhoutingchanjieshushijian',
					prop: 'weekEndTime',
				}, {
					label: 'miaoshu',
					prop: 'remark',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 150,
					fixed: 'right'
				}]
			};
		},
		created() {
			this.getShiftType()
			setTimeout(() => {
				this.yt.conditions.calendarSchemeId = this.$attrs.calendarSchemeId
				this.yt.get(1);
			}, 300)
			// 添加 watch 来监视 yt.editObj.specifyEndTime 的变化
			// this.$watch('yt.editObj.specifyStartTime', (newVal, oldVal) => {
			// 	console.log(newVal)
			// 	// 在这里执行判断逻辑
			// 	this.checkEndTime();
			// });
			// // 添加 watch 来监视 yt.editObj.specifyEndTime 的变化
			// this.$watch('yt.editObj.specifyEndTime', (newVal, oldVal) => {
			// 	console.log(newVal)
			// 	// 在这里执行判断逻辑
			// 	this.checkEndTime();
			// });
			// // 添加 watch 来监视 yt.editObj.weekEndTime 的变化
			// this.$watch('yt.editObj.weekEndTime', (newVal, oldVal) => {
			// 	console.log(newVal)
			// 	// 在这里执行判断逻辑
			// 	this.checkWeekEndTime();
			// });
			// // 添加 watch 来监视 yt.editObj.weekEndTime 的变化
			// this.$watch('yt.editObj.weekStartTime', (newVal, oldVal) => {
			// 	console.log(newVal)
			// 	// 在这里执行判断逻辑
			// 	this.checkWeekEndTime();
			// });

		},
		watch(){
			
		},
		
		methods: {
			checkWeekEndTime() {
				if (this.yt.editObj.shutdownType != null && this.yt.editObj.shutdownType != undefined) {
					if (this.yt.editObj.shutdownType=='2'){
						if (this.yt.editObj.weekStartTime == null || this.yt.editObj.weekStartTime == undefined) {
							this.$message.error(this.$t('qingxuanzekaishishijian'));
							this.yt.editObj.weekEndTime = '';
						}
					}
					const weekStartTime = this.yt.editObj.weekStartTime;
					const weekEndTime = this.yt.editObj.weekEndTime;
					
					if (weekStartTime && weekEndTime) {
						const startTime = new Date(`1970-01-01 ${weekStartTime}`);
						const endTime = new Date(`1970-01-01 ${weekEndTime}`);
					
						if (startTime >= endTime) {
							this.$message.error(this.$t('jieshushijianbunengzaoyukaishishijian'));
							// 如果需要，可以重置值
							this.yt.editObj.weekEndTime = ''; // 清除结束时间
						}
					}
				}
			},
			checkEndTime() {
				if (this.yt.editObj.shutdownType != null && this.yt.editObj.shutdownType != undefined) {
					if(this.yt.editObj.shutdownType=='1'){
						if (this.yt.editObj.specifyStartTime == null || this.yt.editObj.specifyStartTime == undefined) {
							this.$message.error(this.$t('qingxuanzekaishishijian'));
							this.yt.editObj.specifyEndTime = new Date().getTime();
						}
						const specifyStartTime = new Date(this.yt.editObj.specifyStartTime).getTime();
						const specifyEndTime = new Date(this.yt.editObj.specifyEndTime).getTime();
						
						if (specifyEndTime < specifyStartTime) {
							// 处理错误，例如显示一条消息
							this.$message.error(this.$t('jieshushijianbunengzaoyukaishishijian'));
							// 如果需要，你可以将 yt.editObj.specifyEndTime 重置为旧值
							this.yt.editObj.specifyEndTime = new Date().getTime();
						}
					}
				}
			},
			beforeAdd(params) {
				console.log(this.$attrs)
				params.calendarSchemeId = this.$attrs.calendarSchemeId
				// if(params.shutdownType=="2"){
				// 	params.weekStartTime = this.dayjs(params.weekStartTime/1000).format('HH:mm:ss')
				// 	params.weekEndTime = this.dayjs(params.weekEndTime/1000).format('HH:mm:ss')
				// }

				return params
			},
			getShiftType() {
				this.http.get('/web/setting/shiftType/list').then((res) => {
					this.shifts = res.data
				}).catch((msg) => {
					this.utils.errorMessage(msg);
				})
			},


		}
	};
</script>